// extracted by mini-css-extract-plugin
export default {"paneMenu":"paneMenu---WeDbS"};